import React, { useState } from 'react';
import ConstitutionKanban from './ConstitutionKanban';
import { useTranslation } from 'react-i18next';
import api from '../../api';
import useGet from '../../hooks/useGet';
import EmptyPage from '../../components/EmptyPage';
import { faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import PageIntro from '../../components/PageIntro';
import TablePagination from '../../components/Pagination';
import tableStyles from '../../styles/tableStyles';


const Constitution = () => {
    const { t } = useTranslation();
    const tr = (key) => {
        return t(`constitution:${key}`);
    };
    const PAGE_CONFIG = {
        BREADCRUMB: [
            { label: tr('Home'), link: '/' },
            { label: tr('constitution'), link: '/constitution' }
        ],
        PAGE_TITLE: tr('pageTitle'),
        GET_QUERY_KEY: 'constitution',
        PAGE_DESCRIPTION: tr('pageDescription'),
        API_CALL: () => api.constitutions.getConstitutions(),
        DEFAULT_ERROR_MESSAGE: tr('defaultErrorMessage'),
        SELECT: (data) => data?.data,
        EMPTY_PAGE_ICON: faBalanceScale,
        SEARCH_DESCRIPTION: tr('searchDescription'),
        SEARCH_PLACEHOLDER: tr('searchPlaceholder'),
        SEARCH_LOADING_MESSAGE: tr('searchLoadingMessage')
    };
    const [params, setParams] = useState({
        page: 1,
        limit: 10,
        search: ''
    });
    const handlePageChange = (newPage) => {
        if (newPage < 1) return;
        setParams((prev) => ({ ...prev, page: newPage }));
    };

    const handlePageSizeChange = (limit) => {
        if (limit < 1) return;
        setParams((prev) => ({ ...prev, limit }));
    };

    const { data, pagination, isLoading } = useGet(PAGE_CONFIG.GET_QUERY_KEY, () => api.constitutions.getConstitutions(params), PAGE_CONFIG.DEFAULT_ERROR_MESSAGE, PAGE_CONFIG.SELECT, params);
    const { page, limit, totalCount } = pagination;
    const totalPages = Math.ceil(totalCount / limit);
    return (
        <div>
            <PageIntro description={PAGE_CONFIG.PAGE_DESCRIPTION} />
            <div className="text-sm text-gray-500 ml-2 mt-4 dark:text-gray-400">
                {tr('showing')} {data?.length} {tr('of')} {pagination.totalCount} 
            </div>
            {data?.length > 0 ? (
                <ConstitutionKanban data={data} tr={tr} />
            ) : (
                <EmptyPage colSpan={12} isLoading={isLoading} icon={faBalanceScale} description={PAGE_CONFIG.SEARCH_DESCRIPTION} placeholder={PAGE_CONFIG.SEARCH_PLACEHOLDER} loadingMessage={PAGE_CONFIG.SEARCH_LOADING_MESSAGE} />
            )}
            <TablePagination totalPages={totalPages} page={page} limit={limit} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} tableStyles={tableStyles} />
        </div>
    );
};

export default Constitution;
